"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.failure = exports.success = exports.isSuccess = exports.isFailure = exports.assertUnreachable = exports.difference = exports.union = exports.range = exports.zip = exports.mapObjectValues = void 0;
function mapObjectValues(object, map) {
    return Object.entries(object).reduce((result, [key, value]) => ({ ...result, [key]: map(value) }), {});
}
exports.mapObjectValues = mapObjectValues;
function zip(xs, ys) {
    const limit = Math.min(xs.length, ys.length);
    return xs.slice(0, limit).map((x, i) => [x, ys[i]]);
}
exports.zip = zip;
function range(start, end) {
    if (end <= start) {
        return [];
    }
    else {
        return [...Array(end - start).keys()].map(index => index + start);
    }
}
exports.range = range;
function union(s1, s2) {
    return new Set([...s1, ...s2]);
}
exports.union = union;
function difference(s1, s2) {
    return new Set([...s1].filter(el => !s2.has(el)));
}
exports.difference = difference;
function assertUnreachable(x) {
    throw Error('This code should be unreachable');
}
exports.assertUnreachable = assertUnreachable;
function isFailure(result) {
    return result.kind === ResultKind.Failure;
}
exports.isFailure = isFailure;
function isSuccess(result) {
    return result.kind === ResultKind.Success;
}
exports.isSuccess = isSuccess;
function success(value) {
    return {
        kind: ResultKind.Success,
        value,
    };
}
exports.success = success;
function failure(error) {
    return {
        kind: ResultKind.Failure,
        error,
    };
}
exports.failure = failure;
var ResultKind;
(function (ResultKind) {
    ResultKind["Success"] = "Success";
    ResultKind["Failure"] = "Failure";
})(ResultKind || (ResultKind = {}));
//# sourceMappingURL=util.js.map